import { ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';

type PageProps = ComponentPropsWithoutRef<'div'>;

export default function Page({ className, ...props }: PageProps) {
  return (
    <div className={classNames('w-full h-full sm:rounded-4xl bg-bg overflow-auto shadow-base-back-3-transparent shadow-down-lg relative', className)} {...props} />
  );
}
